// scheduling/components/OnSiteToggle.jsx
// Shared "On-site" affordance for a job, used on every surface that shows/sets the
// flag (ManagerDashboard My Jobs, ClientView, the grid job sidebar + schedule modal).
// - Read-only (no edit rights): renders the On-site badge when the job is on-site,
//   otherwise nothing.
// - Editable (JM/JP or superuser): renders a clickable pill. Enabling shows a brief
//   confirmation explaining the effect; disabling is immediate (per design).
export default function OnSiteToggle({ isOnSite, office, officeCode, canEdit, onChange, style }) {
  const officeLabel = office || officeCode || 'the job office';

  const apply = (next) => {
    if (next) {
      const ok = window.confirm(
        `Mark this job on-site?\n\nStaff suggestions for it will be limited to ${officeLabel} staff, and assigning someone from another office will show a warning.`
      );
      if (!ok) return;
    }
    onChange(next);
  };

  if (!canEdit) {
    if (!isOnSite) return null;
    return (
      <span className="sched-onsite-badge" style={style} title={`On-site job — ${officeLabel}`}>
        &#128205; On-site{officeCode ? ` · ${officeCode}` : ''}
      </span>
    );
  }

  return (
    <button
      type="button"
      className={`sched-onsite-toggle${isOnSite ? ' sched-onsite-toggle--on' : ''}`}
      style={style}
      onClick={(e) => { e.stopPropagation(); apply(!isOnSite); }}
      title={isOnSite
        ? `On-site job — ${officeLabel}. Click to clear.`
        : 'Mark this job on-site (limits staff suggestions to its office)'}
    >
      &#128205; {isOnSite ? `On-site${officeCode ? ` · ${officeCode}` : ''}` : 'On-site?'}
    </button>
  );
}
